
























import Vue from "vue";
import Component from "vue-class-component";
import { mapGetters } from "vuex";
import { AuthState, AuthActionTypes, namespaceAuth } from "../../store/auth";

@Component({
  name: "HeaderTopPanelLoginButton",
  computed: {
    ...mapGetters(namespaceAuth, {
      isLoggedIn: "isLoggedIn",
      email: "getEmail"
    })
  }
})
export default class HeaderTopPanelLoginButton extends Vue {
  logout() {
    this.$store.dispatch(`${namespaceAuth}/${AuthActionTypes.Logout}`);
    if (this.$route.path !== "/") {
      this.$router.push("/");
    }
  }
}
